export default __webpack_public_path__ + "static/media/icon-info-grey.0cbe93df.svg";